import React from 'react';
import { X } from 'lucide-react';

const LegalModal = ({ type, onClose }) => {
  if (!type) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm px-5">

      <div className="max-w-2xl w-full max-h-[80vh] overflow-y-auto rounded-2xl bg-black border border-white/10 p-8 shadow-2xl">

        <div className="flex justify-between items-center mb-6">

          <h2 className="text-xl font-semibold text-white">
            {type === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}
          </h2>

          <button
            onClick={onClose}
            className="text-white/50 hover:text-white transition"
          >
            <X size={22} />
          </button>

        </div>

        <div className="space-y-5 text-sm text-white/60 leading-relaxed">

          {type === 'privacy' ? (
            <>
              <p>
                NRFSTR builds software products that may collect information
                needed to provide services, process payments, and improve user
                experiences.
              </p>

              <p>
                NRFSTR may collect account information, payment-related
                information through third-party payment providers, and product
                usage information as features and analytics systems are developed.
              </p>

              <p>
                Future NRFSTR products may use analytics and data collection
                tools to improve performance, reliability, and functionality.
              </p>

              <p>
                NRFSTR takes reasonable steps to protect user information and
                does not sell personal information.
              </p>

              <p>
                Privacy questions can be sent to:
                <br />
                Tyseandavis42@gmail.com
              </p>
            </>
          ) : (
            <>
              <p>
                NRFSTR creates both free and paid software products.
              </p>

              <p>
                Product availability, features, pricing, and functionality may
                change as NRFSTR continues development.
              </p>

              <p>
                Users agree to use NRFSTR products responsibly and in
                accordance with applicable laws.
              </p>

              <p>
                NRFSTR software, branding, and intellectual property remain
                the property of NRFSTR unless otherwise stated.
              </p>

              <p>
                NRFSTR does not guarantee uninterrupted service or that products
                will always be free of errors.
              </p>
            </>
          )}

        </div>

      </div>

    </div>
  );
};

export default LegalModal;